export enum PhoneStatus {
    Unverified = 0, // initial state
    Rejected = 1, // the phone number is not a format supported
    Locked = 2, // to many tried to validate it, need to be unlocked by admin
    Verified = 3  // the phone has been verified to be ok (either via SMS or admin)
}
